import { render, staticRenderFns } from "./ClosetDrawerContentPage.vue?vue&type=template&id=8b659792&scoped=true"
import script from "./ClosetDrawerContentPage.vue?vue&type=script&lang=js"
export * from "./ClosetDrawerContentPage.vue?vue&type=script&lang=js"
import style0 from "./ClosetDrawerContentPage.vue?vue&type=style&index=0&id=8b659792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b659792",
  null
  
)

export default component.exports